<template>
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
    <core-upsell-product-card
      v-for="product in products"
      :key="product.sku"
      :product="product"
      :category="product.type === 'permanent' ? 'Permanent' : 'Subscription'"
      :title="product.label"
      :suffix="product.isMonthly ? ' USD/per month' : ' USD'"
      :description="product.addendum"
      :featured="product.featured"
      :loading="isAddingToCart"
      @cta="emit('addToCart', product)"
    />
  </div>
</template>

<script setup>
  defineProps({
    products: {
      type: Array,
      required: true
    },
    isAddingToCart: Boolean
  });

  const emit = defineEmits(['addToCart']);
</script>
